


export const formatHourLabel = (key: string) => {
  const labelMap: Record<string, string> = {
    "7to8": "7:00 - 8:00",
    "8to9": "8:00 - 9:00",
    "9to10": "9:00 - 10:00",
    "10to11": "10:00 - 11:00",
    "11to12": "11:00 - 12:00",
    "12to13": "12:00 - 13:00",
    "13to14": "13:00 - 14:00",
    "14to15": "14:00 - 15:00",
    "15to16": "15:00 - 16:00",
    "16to17": "16:00 - 17:00",
    "17to18": "17:00 - 18:00",
    "18to19": "18:00 - 19:00",
    "19to20": "19:00 - 20:00",
    "20to21": "20:00 - 21:00",
    "21to22": "21:00 - 22:00",
  };

  return labelMap[key] || key;
};
